import { React, useState, useEffect, lazy, Suspense } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'

import { useTranslation } from 'react-i18next'
import { t } from 'i18next'
import { Helmet } from 'react-helmet-async'
import { isMobile } from 'react-device-detect'
import { LazyLoadImage } from 'react-lazy-load-image-component';
import styled from 'styled-components'
import Select from 'react-select'

import { useLoginPopup, useQuickRegisterPopup } from '../../../contexts/LoginPopupProvider'
import { useUserLogged } from '../../../contexts/UserLoggedProvider'
import { useUserSession } from '../../../contexts/UserSessionProvider'
import { useAppColorTheme } from '../../../contexts/AppOptionsProvider'
import { useUserLang } from '../../../contexts/LanguageSwitcherProvider'
import { headerMainMenu } from './HeaderData'

import useGetWPAxios from '../../../api/useGetWPAxios'

import './Header.scss'
//import Cookies from 'universal-cookie'
//import CountdownTimer from '../../Utils/CountdownTimer/CountdownTimer'

const renderLoader = () => <></>


const Button = lazy(() => import('../../Utils/Button/Button'))

const AmountComponent = lazy(() => import('./ServiceMenu/AmountComponent'))
const DepositComponent = lazy(() => import('./ServiceMenu/DepositComponent'))

const UserComponent = lazy(() => import('./ServiceMenu/UserComponent'))

const HeaderMenu = lazy(() => import('../../Navigation/HeaderMenu/HeaderMenu'))
const BurgerMenuButton = lazy(() => import('./BurgerMenu/BurgerMenuButton'))
const BurgerMenu = lazy(() => import('./BurgerMenu/BurgerMenu'))

const Logo = lazy(() => import('./Logo'))

//const AccountHeaderExtra = lazy(() => import('./AccountHeaderExtra'))

const QuickRegister = lazy(() => import('../../Authentication/QuickRegister/QuickRegister'))

const LoginForm = lazy(() => import('../../Authentication/LoginForm/LoginForm'))

//const LuckyDraw = lazy(() => import('./ServiceMenu/LuckyDraw'))
//const Popup = lazy(() => import('../../Utils/Popup/Popup'))
//import LanguageComponent from './ServiceMenu/LanguageComponent'


const langOptions = [
    { value : 'en' , label: "EN"},
    { value : 'es' , label: "ES"},
    { value : 'ru' , label: "RU"},
]

export default function Header(){

    const { userSession } = useUserSession()
    const { userLogged } = useUserLogged()
	const { i18n } = useTranslation()

    const history = useLocation()
    const navigate = useNavigate()
    
    const colorTheme = useAppColorTheme()
    const [ themeColor, setThemeColor] = useState('#161f2c')
    const [ burgerMenuOpened, setBurgerMenuOpened] = useState(false)

    const [ scrollTop, setScrollTop ] = useState(0);
    const [ headerSticky, setHeaderSticky ] = useState(false);
    
    const { quickRegisterPopup } = useQuickRegisterPopup()
    const { loginPopup } = useLoginPopup()
    const { lang, setLang } = useUserLang()

	const { data } = useGetWPAxios('wp/v2/menu?menu_id=82')
    
    /* const cookies =  useMemo(() => new Cookies(), []);
    const [ showLuckyDrawPopup, setShowLuckyDrawPopup ] = useState(false)
    useEffect(() => {
        if(userSession && cookies.get('luckydrawpopup-'+userSession.user.id) === undefined){
            console.log(cookies.get('luckydrawpopup-'+userSession.user.id))
            var midnight = new Date();
            midnight.setHours(23,59,59,0);
            cookies.set('luckydrawpopup-'+userSession.user.id,  1, {expires: midnight});
            setTimeout(() => {
                setShowLuckyDrawPopup(true)
            }, 1000)
        }else{
            setShowLuckyDrawPopup(false)
        }
    }, [cookies,userSession]) */

    useEffect(() => {
        if(history.pathname === '/live-casino' || 
        history.pathname === '/mima-games/live-poker') {
            setThemeColor('#F69534')
        } else if (history.pathname === '/casino') {
            setThemeColor('#E25454')
        } else if(history.pathname === '/sports') {
            setThemeColor('#23A04A')
        } else if (history.pathname === '/') {
            setThemeColor('#161f2c')
        } else {
            setThemeColor('#161f2c')
        }
    },[history]);

    
    useEffect(() => {
        
        if(isMobile) return

        const onScroll = e => {
            if(history.pathname.includes('game/live-poker_mima')){
                setHeaderSticky(false)
            }else{
                if(e.target.documentElement){
                    setScrollTop(e.target.documentElement.scrollTop);
                    setHeaderSticky(e.target.documentElement.scrollTop > 5);
                }
            }
        };
        window.addEventListener("scroll", onScroll);
    
        return () => window.removeEventListener("scroll", onScroll);
    }, [scrollTop, history]);

    useEffect(() => {
        i18n.changeLanguage(lang)
        localStorage.setItem("lang", lang)
    }, [i18n, lang])

    return (
        <>

            <Helmet>
                <title>{ t(process.env.REACT_APP_MAIN_TITLE) }</title>
                <link rel="icon" href={"/favicon-"+ colorTheme +".png"} />
                <link rel="apple-touch-icon" href={"/favicon-"+ colorTheme +".png"} />
                <meta name="theme-color" content={themeColor} />
                <meta name="description" content={t(process.env.REACT_APP_MAIN_DESCRIPTION)} />
                {/* <script>
                    var io_install_flash = false;
                    var io_install_stm = false;
                </script>
                <script type="text/javascript" src="https://mpsnare.iesnare.com/snare.js"></script> */}
            </Helmet>

            <SiteHeader className={"theme-" + colorTheme + (headerSticky ? ' sticky' : '')}>
                <div className="inner-header">
                    <Suspense fallback={renderLoader()}>
                        <div className="logo">
                            <Link title="Logo" alt="Logo" to={`/${lang!=='en' ? lang : ''}`}>
                                <div className="main-logo">
                                    { <Logo className={colorTheme} /> }
                                </div>
                                <div className="mobile-logo">
                                    <LazyLoadImage width="24" height="24" src="/images/logos/mobile-logo.svg" alt="Mobile Logo" />
                                </div>
                            </Link>
                        </div>
                        <div className="menu-wrap">
                            <BurgerMenuButton open={burgerMenuOpened} setOpen={setBurgerMenuOpened} />
                            <BurgerMenu items={headerMainMenu} open={burgerMenuOpened} setOpen={setBurgerMenuOpened} />
                            <HeaderMenu items={headerMainMenu} />
                        </div>
                        
                        <div className='login-wrap'>
                            {/* <LanguageComponent /> */}
                            <SelectLangInput
                                classNamePrefix="lang-select" 
                                className="lang-input" 
                                options={langOptions} 
                                onChange={(e) => { 
                                    if(e.value==='en'){
                                        navigate(history.pathname.replace('/' + lang, ''))
                                    }else{
                                        if(lang==='en'){
                                            const newPath = history.pathname!=='/' ? `/${e.value}${history.pathname}`:`/${e.value}` 
                                            navigate(newPath)
                                        }else{
                                            navigate(history.pathname.replace(`/${lang}`, `${e.value}`))
                                        }
                                    }
                                    setLang(e.value)
                                }} 
                                value={langOptions && langOptions.filter(pp => pp.value === lang)} 
                                placeholder={t('Select Language')} />

                            { userLogged && userSession && (
                                <>
                                    {/* <AccountHeaderExtra userSession={userSession && userSession} /> */}
                                    <CurrentUser email={userSession.email} />
                                    {/* { showLuckyDrawPopup && <Popup showLuckyDrawPopup={showLuckyDrawPopup} /> } */}
                                </>
                            )}

                            { !userLogged && !userSession && <LoginRegisterButtons colorTheme={colorTheme} /> }

                        </div>
                    </Suspense>
                </div>
                <HeaderBelow>
                    { t("New games coming soon:") }
                    <HeaderGamesNav>
                        { data && data.map((menu, index) => {
                            return <GameItem to={(lang !== 'en' ? '/' + lang : '') + menu.url} key={index}>{ menu.name }</GameItem>
                        }) }
                    </HeaderGamesNav>
                </HeaderBelow>
                {/* <SiteHeaderChristmasLights src="/images/christmas/christmas-lights.png" /> */}
                {/* <div className="countdown_timer">
                    <div className='countdown-wrap'>
                        { now < LaunchDate && 
                        <div>Official Launch Party </div>}
                        <CountdownTimer LaunchDate={LaunchDate}/>
                    </div> 
                </div>  */}
            </SiteHeader>
            
            <Suspense fallback={renderLoader()}>
                <>
                    { quickRegisterPopup && <QuickRegister /> }
                    { loginPopup && <LoginForm returnPath={history?.state?.returnPath} /> }
                </>
            </Suspense>
            
        </>

        
    )
    
}


const CurrentUser = () => {

    return (
        <div style={{ opacity: 1 }} className="service-menu">
            {/* { <div className="balance lucky-draw-wrap">
                    <LuckyDraw/>
                </div> } */}
            <div className="balance">
                <AmountComponent />
                <DepositComponent />
            </div>
            <UserComponent />
        </div>
    )
}

const LoginRegisterButtons = ({ colorTheme }) => {
    
    const { setLoginPopup } = useLoginPopup()
    const {setQuickRegisterPopup } = useQuickRegisterPopup()

    return (
        <div className="buttons">
            <Button secondary colorTheme={colorTheme} onClickEvent={ () => { 
                setLoginPopup(true); }}>{ t("Login") }</Button>
            <Button colorTheme={colorTheme} onClickEvent={ () => { setQuickRegisterPopup(true); }}>{ t("Sign Up") }</Button>
        </div>
    )
}


const SiteHeader = styled.header`
    /* background-image: url('/images/christmas/snowflakes.png'); */
    background-size: auto 80%;
    background-repeat: repeat-x;
`

/* const SiteHeaderChristmasLights = styled.div`
    position: absolute;
    width: 100%;
    height: 20px;
    opacity: 0.8;
    background-size: auto 100%;
    background-repeat: repeat-x;
    background-image: url(${props => props.src});
    z-index: 90;
    bottom: 0;
    transform: translateY(80%);
` */



const SelectLangInput = styled(Select)`
    .lang-select__control{
        background: none;
        min-height: 48px;
        min-width: 80px;
        border-width: 2px;
        border-radius: 0.5rem;
        margin-right: 1rem;
        &.lang-select__control--is-focused{
            box-shadow: 0px 5px 15px black;
            border-color: var(--orange-hover);
        }
        @media (min-width: 0px) and (max-width: 767px){
            min-height: 35px;
            margin-right: 0.5rem;
    
        }   
    }
    .lang-select__value-container{
        font-size: 1.125rem;
        @media (min-width: 0px) and (max-width: 767px){
            font-size: 0.875rem;
    
        }  
    }
    .lang-select__indicator{
        padding: 0.25rem;
    }
    .lang-select__single-value{
        color: white;
    }
    .lang-select__menu{
        background: #545454;
        font-size: 1rem;
        margin-top: 0px;
    }
    .lang-select__menu-list{
        padding: 0;
    }
    .lang-select__option{
        &.lang-select__option--is-focused,
        &.lang-select__option--is-selected{
            background-color: var(--orange-hover);
        }
    }
`

const HeaderBelow = styled.div`
    background: linear-gradient(314deg, #2c2c2c, #111111);
    display: flex;
    align-items: center;
    justify-content: flex-end;
    position: relative;
    z-index: 900;
    padding: 0.25rem 2rem;
    font-size: 7px;
    @media (min-width: 420px){
        font-size: 9px;
    }
    @media (min-width: 768px){
        font-size: 12px;
    }
    @media (min-width: 0px) and (max-width: 767px){
        font-size: 8px;
    }
`

const HeaderGamesNav = styled.nav`
`
const GameItem = styled(Link)`
    color: white;
    font-weight: bold;
    text-decoration: none;
    margin-left: 0.5rem;
    &:hover{
        color: silver;
    }
`
